/**
 * Mock Playlist Data
 * Temporary data source until R2 fetch is implemented
 * 
 * TODO: Replace with actual R2 fetch in musicPlaylistThunks.ts
 */

import { Playlist, Track } from '@/types/MusicPlaylist';

export const mockTracks: Track[] = [
  {
    id: '1',
    title: 'Sky Frequency',
    artist: 'Ambient Pilot',
    audioUrl: '/audio/test/track1.mp3',
    coverUrl: 'https://picsum.photos/seed/track1/400/400',
    duration: 245,
    metadata: {
      album: 'Terminal Sessions',
      year: 2024,
      genre: 'Electronic',
      streamingLinks: {
        spotify: 'https://open.spotify.com/track/example',
      }
    }
  },
  {
    id: '2',
    title: 'Runway Dreams',
    artist: 'Frequency Collective',
    audioUrl: '/audio/test/track2.mp3',
    coverUrl: 'https://picsum.photos/seed/track2/400/400',
    duration: 298,
    metadata: {
      album: 'Terminal Sessions',
      year: 2024,
      genre: 'Ambient',
    }
  },
  {
    id: '3',
    title: 'Control Tower Nights',
    artist: 'The Aviators',
    audioUrl: '/audio/test/track3.mp3',
    coverUrl: 'https://picsum.photos/seed/track3/400/400',
    duration: 267,
    metadata: {
      album: 'Flight Path',
      year: 2024,
      genre: 'Electronic',
    }
  },
  {
    id: '4',
    title: 'Departure Lounge',
    artist: 'Sky Radio',
    audioUrl: '/audio/test/track1.mp3',
    coverUrl: 'https://picsum.photos/seed/track4/400/400',
    duration: 312,
    metadata: {
      album: 'Airways',
      year: 2024,
      genre: 'Chill',
    }
  },
  {
    id: '5',
    title: 'Cleared for Takeoff',
    artist: 'Ambient Pilot',
    audioUrl: '/audio/test/track2.mp3',
    coverUrl: 'https://picsum.photos/seed/track5/400/400',
    duration: 289,
    metadata: {
      album: 'Terminal Sessions',
      year: 2024,
      genre: 'Electronic',
    }
  }
];

export const mockPlaylist: Playlist = {
  id: 'chill-airwaves-default',
  name: 'Chill Airwaves Mix',
  description: 'Relaxing tunes for air traffic enthusiasts',
  tracks: mockTracks,
  coverUrl: 'https://picsum.photos/seed/playlist/600/600',
  createdAt: '2024-01-01T00:00:00Z',
  updatedAt: new Date().toISOString(),
};
